// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ItemsPendingExitLaudoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/items_pending_exit_laudo
 *
 * List of service items pending confirmed exit report.
 */
import type { Orders_PendingLaudoItemRow } from './Orders_PendingLaudoItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_ItemsPendingExitLaudoResponseDados = Orders_PendingLaudoItemRow[];

export type Orders_ItemsPendingExitLaudoResponse = ApiResponse<Orders_ItemsPendingExitLaudoResponseDados>;

registerResponseContract('Orders_ItemsPendingExitLaudoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_order_item_id:                          { type: 'number',  required: true },
      so_order_item_order_id:                    { type: 'number',  required: true },
      so_order_item_type:                        { type: 'string',  required: true },
      so_order_item_parent_item_id:              { type: 'number',  required: false },
      so_order_item_service_id:                  { type: 'number',  required: false },
      so_order_item_additional_service_id:       { type: 'number',  required: false },
      so_order_item_additional_service_price_id: { type: 'number',  required: false },
      so_order_item_priority_id:                 { type: 'number',  required: false },
      so_order_item_product_id:                  { type: 'number',  required: false },
      so_order_item_quantity:                    { type: 'number',  required: true },
      so_order_item_unit_price:                  { type: 'number',  required: true },
      so_order_item_description:                 { type: 'string',  required: false },
      so_order_item_discount_type:               { type: 'string',  required: false },
      so_order_item_discount_value:              { type: 'number',  required: false },
      so_order_item_total:                       { type: 'number',  required: true },
      so_order_item_deadline_days:               { type: 'number',  required: false },
      so_order_item_qrcode:                      { type: 'string',  required: false },
      so_order_item_franchise_id:                { type: 'number',  required: false },
      so_order_item_delivered_at:                { type: 'string',  required: false },
      so_order_item_expected_delivery_at:        { type: 'string',  required: false },
      so_order_item_created_at:                  { type: 'string',  required: true },
      so_order_id:                               { type: 'number',  required: true },
      so_order_status:                           { type: 'string',  required: true },
      so_order_created_at:                       { type: 'string',  required: true },
      so_order_client_id:                        { type: 'number',  required: false },
      so_order_client_name:                      { type: 'string',  required: false },
      so_service_name:                           { type: 'string',  required: false },
      so_priority_name:                          { type: 'string',  required: false },
      so_service_category_name:                  { type: 'string',  required: false },
      franchise_name:                            { type: 'string',  required: false },
      item_description_value:                    { type: 'string',  required: false },
      so_order_item_alerts:                      { type: 'string',  required: false },
      so_order_item_notes:                       { type: 'string',  required: false },
      so_order_item_service_label:               { type: 'string',  required: false },
    },
  },
})
